import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { InputLabel, TextField } from "@mui/material";
import { Popup } from "components/UI/Popup";
import { ICollection } from "services/types";
import { ToggleButton } from "components/buttons/ToggleButton";
import { editCollection } from "store/collections/collections-action";
import { ReactComponent as TrashIcon } from "components/icons/trash.svg";
import "./styles/EditCollectionPopup.scss";

interface IEditCollectionPopupProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleDeleteCollection: () => void;
  collection: ICollection;
}

export const EditCollectionPopup = ({ isOpen, togglePopup, handleDeleteCollection, collection }: IEditCollectionPopupProps) => {
  const { control, handleSubmit, reset } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (data: any) => {
    data.published = !data.published;
    dispatch(editCollection({
      ...data,
      collectionId: collection.folderId
    }));
    togglePopup();
  };

  useEffect(() => {
    reset({
      published: !collection.published,
      folderName: collection.folderName,
      description: collection.description ? collection.description : ""
    });
    // eslint-disable-next-line
  }, [collection])

  const btnProps = {
    type: 1,
    title: "Save changes",
    formId: "edit-collection-form",
    btnType: "submit"
  };

  return (
    <Popup
      title="Edit a Collection"
      isOpen={isOpen}
      popupClass="EditCollectionPopup"
      onClose={togglePopup}
      btnProps={btnProps}
    >
      <form onSubmit={handleSubmit(onSubmit)} id="edit-collection-form">
        <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>Collection name</InputLabel>
        <Controller
          name="folderName"
          control={control}
          defaultValue=""
          rules={{ required: "Required Field!" }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              sx={{
                ".Mui-focused, & div": {
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)!important",
                    borderWidth: "1px"
                  }
                },
                "& div": {
                  borderRadius: "12px",
                  margin: "0.5rem 0",
                  "& input": {
                    padding: "13px 16px",
                    fontSize: "14px",
                    fontFamily: "Poppins, sans-serif",
                    lineHeight: "22px"
                  }
                }
              }}
              fullWidth
              onChange={onChange}
              value={value}
              error={!!error}
            />
          )}
        />
        <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>
          Description
        </InputLabel>
        <Controller
          name="description"
          control={control}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              rows={3}
              multiline
              sx={{
                ".Mui-focused, & div": {
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)!important",
                    borderWidth: "1px"
                  }
                },
                "& div": {
                  borderRadius: "12px",
                  margin: "0.5rem 0",
                  "& textarea": {
                    fontSize: "14px",
                    fontFamily: "Poppins, sans-serif",
                    lineHeight: "22px"
                  }
                }
              }}
              fullWidth
              onChange={onChange}
              value={value}
              error={!!error}
            />
          )}
        />
        <div className="EditCollectionPopup-Toggle">
          <p>Make private</p>
          <Controller
            name="published"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <ToggleButton checked={!!value} onChange={onChange}/>
            )}
          />
        </div>
        <button type="button" className="EditCollectionPopup-DeleteBtn" onClick={handleDeleteCollection}>
          <span><TrashIcon /></span>
          Delete Collection
        </button>
      </form>
    </Popup>
  );
};
